module.exports = __webpack_public_path__ + "img/checkmark.578be442.svg";